import * as yup from "yup";
import { createValidationSchema, validate } from "@";

// Define the validation schema for the form
export const schema = createValidationSchema({
  Title: validate("req", "title"),
  Subtitle: validate("req", "Subtitle"),
  Url: validate("url", "url"),
  Image: yup.string().when(["IsActive", "ImageFullUrl"], {
    is: (isActive, imageFullUrl) => isActive === true && !imageFullUrl,
    then: () => validate("image", "Image"),
    otherwise: () => yup.string().nullable(),
  }),
});

// Define the default values for the form fields
export const defaultValues = {
  Url: null,
  Title: null,
  Image: null,
  Subtitle: null,
  IsActive: false,
  ImageFullUrl: null,
};
